import { GridCell } from '@progress/kendo-react-grid'
import getEnumTranslation from '@/enums/enums'
import React from 'react'

export default ({ localize, enumObject }) => {
  return class FlagsEnumCell extends GridCell {
    render () {
      const value = this.props.dataItem[this.props.field]
      const enumValues = enumObject.values
      const enumValueNames = []

      for (let i = 0; i < enumValues.length; i++) {
        const enumValue = enumValues[i]

        if ((value & enumValue) !== 0) {
          enumValueNames.push(`${getEnumTranslation({ localize, enumName: enumObject.enumName, value: enumValue })}, `)
        }
      }

      if (enumValueNames.length) {
        const lastValue = enumValueNames[enumValueNames.length - 1]
        enumValueNames[enumValueNames.length - 1] = lastValue.substring(0, lastValue.length - 2)
      }

      return (<td>{enumValueNames}</td>)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.FlagsEnumCell.js